import type { GridApi } from "ag-grid-enterprise";
import { createContext, useContext } from "react";

export interface ActiveGridContextValue {
  /** The api of the last-ready grid still alive, or null if none. */
  api: GridApi | null;
  /** Called by a DataTable when its grid becomes ready. */
  register: (api: GridApi) => void;
  /** Called by a DataTable as its grid is destroyed, naming the grid that went. */
  unregister: (api: GridApi) => void;
}

function noop() {}

// Safe default: when there is no ActiveGridProvider (Storybook, tests, any
// DataTable rendered outside the app shell), register/unregister are no-ops and
// `api` is null — so existing grids are completely unaffected.
export const ActiveGridContext = createContext<ActiveGridContextValue>({
  api: null,
  register: noop,
  unregister: noop
});

/** Read the last-ready grid still alive. */
export function useActiveGrid(): ActiveGridContextValue {
  return useContext(ActiveGridContext);
}
